import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { 
  BarChart2, 
  Package, 
  Users, 
  Building2, 
  ShoppingCart, 
  FileText, 
  Factory,
  ClipboardList,
  BarChart3,
  Truck,
  Package2,
  Store,
  Warehouse,
  Receipt,
  ArrowRight,
  FileBarChart,
  Trash2,
  Hash
} from 'lucide-react';

interface Report {
  id: string;
  name: string;
  description: string;
  module: string;
  icon: React.ComponentType<{ className?: string }>;
  available: boolean;
}

const reports: Report[] = [
  // // Sales & Purchase Reports
  // {
  //   id: 'sales-order-report',
  //   name: 'Sales Order Report',
  //   description: 'Sales orders with status, quantities, and customer details',
  //   module: 'Sales & Orders',
  //   icon: FileText,
  //   available: true
  // },
  // {
  //   id: 'purchase-order-report',
  //   name: 'Purchase Order Report',
  //   description: 'Purchase orders with supplier information and delivery status',
  //   module: 'Sales & Orders',
  //   icon: ShoppingCart,
  //   available: true
  // },
  // {
  //   id: 'challan-report',
  //   name: 'Challan Report',
  //   description: 'Delivery challans with shipment details and status',
  //   module: 'Sales & Orders',
  //   icon: Truck,
  //   available: true
  // },
  
  
  
  // Inventory Reports
  // {
  //   id: 'grn-report',
  //   name: 'GRN Report',
  //   description: 'Goods Received Notes with receipt details and quantities',
  //   module: 'Inventory',
  //   icon: Truck,
  //   available: true
  // },
  {
    id: 'material-inventory-report',
    name: 'Material Inventory Report',
    description: 'Material inventory levels and stock movements',
    module: 'Inventory',
    icon: Warehouse,
    available: true
  },
  {
    id: 'material-issue-report',
    name: 'Material Issue Report',
    description: 'Material issuance details for work orders',
    module: 'Inventory',
    icon: Package2,
    available: true
  },
  {
    id: 'finished-goods-inventory-report',
    name: 'Finished Goods Inventory Report',
    description: 'Finished goods stock with quantities and total boxes',
    module: 'Inventory',
    icon: Package,
    available: true
  },

  // Purchase Reports
  {
    id: 'supplier-performance-report',
    name: 'Supplier Performance Report',
    description: 'Supplier performance metrics including PO, GRN, delivery, and quality metrics',
    module: 'Purchase',
    icon: Building2,
    available: true
  },
  {
    id: 'supplier-balance-report',
    name: 'Supplier Balance Report',
    description: 'Supplier balance report showing PO quantities vs received quantities with remaining balances',
    module: 'Purchase',
    icon: Package,
    available: true
  },

  // Sales Reports
  {
    id: 'sales-order-performance-report',
    name: 'Sales Order Performance Report',
    description: 'Sales order performance metrics with ordered, packed, WIP, invoiced, and pending quantities',
    module: 'Sales',
    icon: FileText,
    available: true
  },
  {
    id: 'hsn-report',
    name: 'HSN Report',
    description: 'HSN and UOM aggregates with billed quantity, taxable value, and CGST / SGST / IGST totals',
    module: 'Sales',
    icon: Hash,
    available: true
  },

  // Production Reports
  {
    id: 'production-report',
    name: 'Production Report',
    description: 'Production summary by branch and date range with work order status and completion details',
    module: 'Production',
    icon: Factory,
    available: true
  },
  // {
  //   id: 'work-order-report',
  //   name: 'Work Order Report',
  //   description: 'Work orders with production status and completion details',
  //   module: 'Production',
  //   icon: Factory,
  //   available: false
  // },
  // {
  //   id: 'wip-report',
  //   name: 'WIP Tracking Report',
  //   description: 'Work in progress tracking with stage-wise status',
  //   module: 'Production',
  //   icon: BarChart3,
  //   available: false
  // },
  
  // Custom Reports
  {
    id: 'mis-report',
    name: 'MIS Report',
    description: 'Monthly Summary Index Report - Last 12 months pivot view',
    module: 'Custom Reports',
    icon: FileBarChart,
    available: true
  },
  {
    id: 'scrap-report',
    name: 'Scrap Report',
    description: 'Daily scrap generation analysis with detailed breakdown by endgood',
    module: 'Production',
    icon: Trash2,
    available: true
  },
  {
    id: 'worker-performance-report',
    name: 'Worker Performance Report',
    description: 'Worker output by date with endgood, process, and quantity',
    module: 'Production',
    icon: Users,
    available: true
  },
  
  // // Packing Reports
  // {
  //   id: 'packing-report',
  //   name: 'Packing Report',
  //   description: 'Packing entries with box details and quantities',
  //   module: 'Packing',
  //   icon: Package2,
  //   available: true
  // },
  
  // // Invoice Reports
  // {
  //   id: 'invoice-report',
  //   name: 'Invoice Report',
  //   description: 'Invoices with tax details and payment status',
  //   module: 'Invoice',
  //   icon: Receipt,
  //   available: true
  // },
  
  // // Store Reports
  // {
  //   id: 'store-master-report',
  //   name: 'Store Master Report',
  //   description: 'Store master data with location and type information',
  //   module: 'Store Management',
  //   icon: Store,
  //   available: true
  // }
];

const ReportsPage: React.FC = () => {
  const navigate = useNavigate();
  const groupedReports = reports.reduce((acc, report) => {
    if (!acc[report.module]) {
      acc[report.module] = [];
    }
    acc[report.module].push(report);
    return acc;
  }, {} as Record<string, Report[]>);

  const handleReportClick = (reportId: string) => {
    // Navigate to specific report pages
    switch (reportId) {
      case 'material-inventory-report':
      case 'rm-inventory-report':
      case 'material-inventory-report':
        navigate('/reports/rm-inventory');
        break;
      case 'material-issue-report':
        navigate('/reports/material-issue');
        break;
      case 'finished-goods-inventory-report':
        navigate('/reports/finished-goods-inventory');
        break;
      case 'supplier-performance-report':
        navigate('/reports/supplier-performance');
        break;
      case 'supplier-balance-report':
        navigate('/reports/supplier-balance');
        break;
      case 'mis-report':
        navigate('/reports/mis');
        break;
      case 'production-report':
        navigate('/reports/production');
        break;
      case 'scrap-report':
        navigate('/reports/scrap');
        break;
      case 'worker-performance-report':
        navigate('/reports/worker-performance');
        break;
      case 'sales-order-performance-report':
        navigate('/reports/sales-order-performance');
        break;
      case 'hsn-report':
        navigate('/invoices/hsn-report');
        break;
      default:
        // console.log('Opening report:', reportId);
        // TODO: Add navigation for other reports
        // navigate(`/reports/${reportId}`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100/50 p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* Header */}
        <Card className="border-0 shadow-lg bg-white/70 backdrop-blur-sm">
          <CardHeader className="bg-gradient-to-r from-primary-50 to-primary-100/50 rounded-t-lg">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-primary-200 flex items-center justify-center">
                <BarChart2 className="h-6 w-6" />
              </div>
              <div>
                <CardTitle className="text-2xl">Reports</CardTitle>
                <CardDescription className="text-primary-100">
                  Access all available reports across modules
                </CardDescription>
              </div>
            </div>
          </CardHeader>
        </Card>

        {/* Reports by Module */}
        {Object.entries(groupedReports).map(([module, moduleReports]) => (
          <Card key={module} className="border-primary-200 shadow-md">
            <CardHeader className="bg-gradient-to-r from-primary-50 to-primary-100/50 border-b border-primary-200">
              <CardTitle className="text-lg text-primary-800">{module}</CardTitle>
              <CardDescription className="text-gray-600">
                {moduleReports.length} {moduleReports.length === 1 ? 'report' : 'reports'} available
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {moduleReports.map((report) => {
                  const Icon = report.icon;
                  return (
                    <Card
                      key={report.id}
                      className="border border-gray-200 hover:border-primary-300 hover:shadow-md transition-all cursor-pointer group"
                      onClick={() => handleReportClick(report.id)}
                    >
                      <CardContent className="p-4">
                        <div className="flex items-start gap-3">
                          <div className="h-10 w-10 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                            <Icon className="h-5 w-5 text-primary-600" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h3 className="font-semibold text-gray-900 mb-1 group-hover:text-primary-700 transition-colors">
                              {report.name}
                            </h3>
                            <p className="text-sm text-gray-600 line-clamp-2">
                              {report.description}
                            </p>
                            <div className="mt-3 flex items-center justify-between">
                              {report.available ? (
                                <span className="text-xs px-2 py-1 bg-green-100 text-green-700 rounded-full">
                                  Available
                                </span>
                              ) : (
                                <span className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded-full">
                                  Coming Soon
                                </span>
                              )}
                              <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-primary-600 transition-colors" />
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  );
                })}
              </div>
            </CardContent>
          </Card>
        ))}

      </div>
    </div>
  );
};

export default ReportsPage;

